export const translations = {
  nav: {
    home: "首页",
    about: "关于我们",
    services: "服务",
    contact: "联系我们"
  },
  hero: {
    title: "唯一专注多伦多大学计算机系学生的团队",
    subtitle: "CS课程 | 职业规划 | 背景提升 一站式服务",
    cta: "立即开始"
  },
  features: {
    title: "为什么选择 CtrlCV？",
    items: [
      {
        title: "最专业的导师",
        description: "全多伦多学术造诣最高的导师团队！",
        longDescription: "CtrlCV团队由一群对CS充满热情的多大毕业生组成。我们的成员都是各自领域的佼佼者，包括北美的资深软件工程师、拥有丰富多大助教经验的硕博士，以及在教学前线活跃的资深教辅人员。",
        icon: "👨‍🏫"
      },
      {
        title: "对学术不端零容忍",
        description: "区别于市面上所有机构，我们绝对不接受任何学术不端行为！",
        longDescription: "我们承诺对学术不端行为零容忍。我们坚信，学术诚信是教育的核心，也是我们团队成员的共同价值观。我们不会容忍任何形式的学术不端行为，包括但不限于抄袭、代写、代考等。我们致力于授人以渔而非授人以鱼。让大家真正的掌握CS技能。",
        icon: "⚖️"
      },
      {
        title: "课程专项辅导",
        description: "我们开设计算机相关的全部课程，开设范围全多伦多最全！",
        longDescription: "我们针对多伦多大学的 CS、GIS、数据分析等课程，提供 1v1、1v2 和班课辅导。计算机相关专业的全部课程，我们都可以提供优质的辅导。",
        icon: "📚"
      },
      {
        title: "背景提升",
        description: "如果你缺乏项目或科研经验，我们会为你提供专业的项目指导，简历修改等。",
        longDescription: "如果你对计算机感兴趣，但是项目或科研经验过少，同时也没有头绪如何去丰富自己的背景，我们会为你提供专业的人生规划，开发/科研项目指导，简历修改等。我们可以为你量身定制属于你的项目，也可以为你提供项目指导。",
        icon: "🚀"
      }
    ]
  },
  members: {
    title: "部分团队成员",
    stories: [
      {
        name: "Mersen",
        role: "全栈工程师，独立开发者",
        quote: "四年超高分刷完多大CS Specialist和滑铁卢工程硕士。曾名列国家级算法竞赛前三，受邀于数字中国建设峰会与院士专家团队分享技术 。近七年国际CS授课经验，学生人数数千计。曾多次参与国内大厂AI基础设施搭建，系统设计，并在加拿大科技行业寒冬期间逆风上岸。"
      },
      {
        name: "Alvin",
        role: "多伦多大学博士在读",
        quote: "本硕博均就读于多伦多大学，累计奖学金超过20万加币及20+段TA，涵盖不同学科体系下机器学习和数据分析课程。研究方向包含时空人工智能以及机器学习在城市空间中的应用，探索人类·自然·城市之间的交互。多次主持参与市政及大学实验设计和环境侦测项目，提供技术支持和数据采集解决方案。"
      },
      {
        name: "Andy",
        role: "高性能分布式优化工程师",
        quote: "高性能分布式软件优化工程师，负责迪斯尼，华纳兄弟，职业运动直播等影视公司的视频控制软件分布式性能优化的解决方案。曾多次在在UTM担任TA，负责大一到大三偏计算机底层课程的助教。丰富tutorial讲解教学经验，带领学生完成lab，协助作业和考试的批改。"
      }
    ]
  },
  services: {
    title: "我们的服务",
    mostPopular: "HOT",
    getStarted: "立即开始",
    items: [
      {
        name: "课程辅导",
        features: [
          "一对一、一对二辅导",
          "班课辅导",
          "每位老师都是前多伦多大学助教",
          "拥有丰富的计算机题库",
          "24/7无限次答疑",
        ]
      },
      {
        name: "背景提升",
        features: [
          "项目定制",
          "项目指导",
          "科研论文",
          "行业大佬手把手亲授",
          "24/7无限次答疑",
        ]
      },
      {
        name: "职业规划",
        price: "赠送",
        period: "90 CAD",
        features: [
          "选课指导",
          "学术规划",
          "职业规划", 
          "简历修改",
        ]
      }
    ]
  },
  faq: {
    title: "常见问题",
    items: [
      {
        question: "如何报名？",
        answer: "请直接联系我们微信或者小红书客服，我们会在第一时间回复您，同时我们现在有丰富的报名优惠活动。"
      },
      {
        question: "覆盖哪些课程？",
        answer: "我们覆盖多大所有核心计算机课程，包括 CSC108、CSC148、CSC207、CSC209、CSC258、CSC263 等。我们采取纯线上的授课形式。"
      },
      {
        question: "是线上还是线下授课？",
        answer: "我们采取纯线上的授课形式。"
      },
      {
        question: "我想要提升个人背景，但我不知道要做什么项目怎么办？",
        answer: "我们提供项目定制服务，您可以告诉我们您的兴趣，我们为您量身定制项目。"
      },
      {
        question: "有课程回放吗？",
        answer: "有的，我们所有课程提供无线次数回放，您可以随时查看。"
      }
    ]
  },
  footer: {
    copyright: "© 2024 CtrlCV Ltd. 保留所有权利。"
  }
}; 